module.exports = __webpack_public_path__ + "img/logoZh.89a07ad3.png";